<script>
    import { spaLink } from "../lib/actions"

    if (typeof window === "undefined") {
        // ssr hint
        // @ts-ignore
        context.is404 = true
    }
</script>

<section class="tp-xxl bp-xxl">
    <div class="container bp-xl">
        <!-- Überschrift Element -->
        <h1>404</h1>
        <h3>Seite nicht gefunden</h3>
    </div>
    <div class="container">
        <div class="col-md-6 col-12">
            <p>
                Die gesuchte Seite wurde möglicherweise entfernt, ihr Name wurde geändert oder sie ist vorübergehend
                nicht verfügbar.
            </p>
            <div class="container tp-l">
                <div class="button-wrap">
                    <a use:spaLink href="/" class="cta btn-primary">zur Startseite</a>
                </div>
            </div>
        </div>
    </div>
</section>

<style lang="less">
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;
        width: 100%;
        h1 {
            padding-bottom: 24px;
        }
        .grid {
            display: flex;
            flex-wrap: wrap;
            gap: 24px;
            .col-md-6 {
                flex: 0 0 50%;
                max-width: 50%;
            }
        }
        .button-wrap {
            display: flex;
            justify-content: flex-start;
            gap: 24px;
        }
    }
    .cta {
        margin-top: 24px;
    }
</style>
